import { Component, computed, inject, OnInit, signal } from "@angular/core";
import ScheduleDetailHeader from "../../../../domains/jobs/components/shared/schedule-detail-header/schedule-detail-header.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AssertionIssue } from "../../../../core/database/db";
import { UiToastService } from "../../../../shared/components/toast/ui-toast.service";
import { SkeletonModule } from "primeng/skeleton";
import { DummyBqInspectionDataService } from "../../services/dummy-bq-inspection-data-service";
import { BqInspectionDataService } from "../../services/bq-inspection-data.service";
import { BqStepDataServiceFactory } from "../../../../personas/shared/bq-step-data-service/bq-step-data-service-factory";
import { DataUpdatedFadeDirective } from "../../../../shared/directives/data-updated-fade.directive";
@Component({
  selector: "app-job-issue-list",
  imports: [ScheduleDetailHeader, SkeletonModule, DataUpdatedFadeDirective],
  providers: [BqStepDataServiceFactory],
  templateUrl: "./job-issue-list.component.html",
  styleUrl: "./job-issue-list.component.scss"
})
export class JobIssueListComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private bqStepDataServiceFactory: BqStepDataServiceFactory
  ) { }
  private toastService = inject(UiToastService);
  private bqStepDataService = signal<BqInspectionDataService>(new DummyBqInspectionDataService(this.toastService));

  dataLoaded: boolean = false;

  areaId = signal<number>(0);
  componentId = signal<number>(0);
  assertionId = signal<number>(0);
  originatingFilter = signal<string | null>(null);


  areas = computed(() => this.bqStepDataService().areas() ?? []);
  componenets = computed(() => this.bqStepDataService().components() ?? []);
  assertions = computed(() => this.bqStepDataService().assertions() ?? []);
  assertionIssues = computed(() => this.bqStepDataService().assertionIssues() ?? []);
  isRefreshingInBackground = computed(() => this.bqStepDataService()?.isRefreshingInBackground() ?? false);
  dataUpdatedPulse = computed(() => this.bqStepDataService()?.dataUpdatedPulse() ?? false);

  job = computed(() => this.bqStepDataService()?.job() ?? (() => {
    throw new Error("Job data not available in BqInspectionDataService");
  })());
  area = computed(() => this.areas().find(area => area.id === this.areaId()) ?? (() => {
    throw new Error("Area not found");
  })());
  component = computed(() => this.componenets().find(component => component.id === this.componentId()) ?? (() => {
    throw new Error("Component not found");
  })());
  assertion = computed(() => this.assertions().find(assertion => assertion.id === this.assertionId()) ?? (() => {
    throw new Error("Assertion not found");
  })());
  jobId = computed(() => this.job().id);

  issues = computed(() =>
    this.assertionIssues()
      .filter(issue =>
        issue.assertionIdentifier === this.assertion().identifier
        && issue.deleted !== 1
      )
  );

  areaComponentSubtitle = computed(() => `${this.area().name} > ${this.component().name}`);

  async ngOnInit(): Promise<void> {
    const bqStep = this.route.snapshot.parent?.data["bqStep"] as string;
    this.bqStepDataService.set(this.bqStepDataServiceFactory.getService<BqInspectionDataService>(bqStep));

    this.areaId.set(parseInt(this.route.snapshot.paramMap.get("areaId") ?? "0"));
    this.componentId.set(parseInt(this.route.snapshot.paramMap.get("componentId") ?? "0"));
    this.assertionId.set(parseInt(this.route.snapshot.paramMap.get("assertionId") ?? "0"));

    this.originatingFilter.set(this.route.snapshot.queryParamMap.get("filter"));

    this.dataLoaded = true;
  }

  public addNewIssue() {
    this.router.navigate(["../needs-attention"],
      {
        relativeTo: this.route,
        queryParams: { from: "job-issue-list", filter: this.originatingFilter() },
      }
    );
  }

  public editIssue(issue: AssertionIssue): void {
    this.router.navigate([issue.id, "details"], { relativeTo: this.route, queryParams: { from: "job-issue-list", filter: this.originatingFilter() } });
  }

  async goBack(): Promise<void> {
    this.router.navigate(["area", this.areaId()], {
      relativeTo: this.route.parent,
      queryParams: { filter: this.originatingFilter() }
    });
  }
}
